import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import DropdownRenderer from './renderers/Dropdown/DropdownRenderer';
import SnippetSelectionRenderer from './renderers/SnippetSelection/SnippetSelectionRenderer.react';
import PassageCorrectionRenderer from './renderers/PassageCorrection/PassageCorrectionRenderer.react';
import BasicRenderer from './renderers/BasicRenderer/BasicRenderer.react';

import './markdown-renderer.scss';

const MarkdownRendererV2 = (props) => {
  const {className, dropdowns, passageCorrection, snippetSelectionData, text} = props;

  let Renderer;

  if (dropdowns) {
    Renderer = DropdownRenderer;
  } else if (snippetSelectionData) {
    Renderer = SnippetSelectionRenderer;
  } else if (passageCorrection) {
    Renderer = PassageCorrectionRenderer;
  } else {
    Renderer = BasicRenderer;
  }

  return (
    <div className={classnames('markdown-renderer-v2', className)}>
      <Renderer {...props} text={!text ? '' : text} />
    </div>
  );
};

MarkdownRendererV2.propTypes = {
  className: PropTypes.string,
  dropdowns: PropTypes.object,
  isBeingTranslated: PropTypes.bool,
  passageCorrection: PropTypes.bool,
  snippetSelectionData: PropTypes.object,
  text: PropTypes.string,
  highlight: PropTypes.string
};

export default MarkdownRendererV2;
